import "./style.css"

export const Total = ()=>{

    let list = localStorage.getItem("list")
    list = JSON.parse(list)

    const listEntrada = list.filter((elem)=> elem.type === "Entrada")
    const listDespesa = list.filter((elem)=> elem.type === "Despesa")

    const resultEntrada = listEntrada.reduce((acumulador, objetoAtual)=>{return acumulador + parseInt(objetoAtual.value)}, 0)
    const resultDespesa = listDespesa.reduce((acumulador, objetoAtual)=>{return acumulador + parseInt(objetoAtual.value)}, 0)
    const resultTotal = resultEntrada - resultDespesa

    return(
        <div className="card-total flex items-start gap-small flex-column">
            <div className="total-header flex items-start justify-between">
                <span className="font-size-4 font-weight-1 font-color-7">Valor Total:</span>
                <span className="font-size-4 font-weight-1 font-color-1">{resultTotal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</span>
            </div>
            <span className="font-size-4 font-weight-2 font-color-6">O valor se refere ao saldo</span>
        </div>
    )
}


